import {Alert, Button, Space, Tabs} from "antd";
import {CallsSection} from "../../calls/upcoming-calls/calls-section";
import {useLiveEvents} from "../../../features/live-events";
import {UpcomingClassesV2} from "../../live-classes/upcoming-classes/v2";
import {FullPageLoader} from "../../full-page-loader";
import {
  StyledNoUpcomingCallBox,
  StyledPageHeaderWrapper,
} from "../../calls/upcoming-calls/upcoming-calls.style";
import {CallCategoryModal} from "../../calls/upcoming-calls/call-category-modal";
import {useEffect, useState} from "react";
import {AnalyticsEvent} from "../../../utils/analytics";
import {CallOfferingModal} from "../call-offering-modal";
import {StyledPageHeader} from "../../../styles/dashboard/calls/calls";
import {Link, useNavigate} from "react-router-dom";
import {getGoogleCalendarSettingsPath} from "../../../services/config";
import {useGetCoachConnectCalendarStatusContext} from "../../../context/connect-calendar/connect-calendar-status.context";
import {useGetCoHostedEvents} from "../../../react-query-hooks/live-events/co-hosts/co-hosts";
import {LiveClassCard} from "../../live-classes/upcoming-classes/card";
import {
  StyledCreateButtonWrapper,
  StyledPopover,
} from "../../../layouts/dashboard-wrapper/dashboard-wrapper.style";
import {PlusOutlined} from "@ant-design/icons";
import {Backdrop} from "../../backdrop";
import {useGetCoachUpcomingCallsContext} from "../../../context/upcoming-calls/coach";

export type TCategoryModalProps = {
  openCallCategoryModal: boolean;
  openOfferingCategoryModal: boolean;
  setOpenCallCategoryModal: React.Dispatch<React.SetStateAction<boolean>>;
  setOpenOfferingCategoryModal: React.Dispatch<React.SetStateAction<boolean>>;
};

export type TUpcomingEventsProps = TCategoryModalProps & {};

export const UpcomingEvents = ({
  openCallCategoryModal,
  setOpenCallCategoryModal,
  openOfferingCategoryModal,
  setOpenOfferingCategoryModal,
}: TUpcomingEventsProps) => {
  const navigate = useNavigate();
  const {
    state: {
      coachUpcomingCallsData: {transactions},
    },
  } = useGetCoachUpcomingCallsContext();
  const getLiveClassesQuery = useLiveEvents({filter: "upcoming", page: 1, perPage: 15});
  const getCoHostedEvent = useGetCoHostedEvents("upcoming");
  const {state: connectCalendarStatus} = useGetCoachConnectCalendarStatusContext();
  const [openPopover, setOpenPopover] = useState(false);

  useEffect(() => {
    const hasSeenPopover = localStorage.getItem("hasSeenPopover");
    const boolHasSeenPopover = !!hasSeenPopover;
    setOpenPopover(!boolHasSeenPopover);
  }, []);

  if (getCoHostedEvent.isLoading) {
    return <FullPageLoader />;
  }

  if (getCoHostedEvent.isError) {
    return (
      <Alert
        message="Error"
        description={getCoHostedEvent.error.message}
        type="error"
        showIcon
      />
    );
  }

  if (getLiveClassesQuery.isLoading) {
    return <FullPageLoader />;
  }

  if (getLiveClassesQuery.isError) {
    return (
      <Alert
        message="Error"
        description={getLiveClassesQuery.error.message}
        type="error"
        showIcon
      />
    );
  }
  const handleOk = () => {
    AnalyticsEvent("Service Option Modal", `Selected a service option`);
    setOpenCallCategoryModal(false);
  };
  const handleCancel = () => {
    AnalyticsEvent("Service Option Modal", `Closed service option modal`);
    setOpenCallCategoryModal(false);
  };
  const showCallCategoryModal = () => {
    // setOpenCallCategoryModal(true);
    navigate("/new-offering?selectOption=event");
  };
  const handleOfferingOk = () => {
    AnalyticsEvent("Service Option Modal", `Selected a service option`);
    setOpenOfferingCategoryModal(false);
    setOpenCallCategoryModal(true);
  };
  const handleOfferingCancel = () => {
    AnalyticsEvent("Service Option Modal", `Closed service option modal`);
    setOpenOfferingCategoryModal(false);
  };
  const showOfferingCategoryModal = () => {
    // setOpenPopover(false);
    // setOpenOfferingCategoryModal(true);
    navigate("/new-offering");
  };
  const flatMapLiveClassPages = getLiveClassesQuery.data?.data ?? [];
  const flatMapCohostPages = getCoHostedEvent.data.pages.flatMap(
    (page) => page?.data ?? []
  );
  const flatMapUpcomingCallPages = transactions;
  const liveClasses = [...flatMapCohostPages, ...flatMapLiveClassPages];
  const allEvents = [
    ...flatMapCohostPages,
    ...flatMapUpcomingCallPages,
    ...flatMapLiveClassPages,
  ];
  console.log({
    cohost: getCoHostedEvent.data,
    liveClasses: getLiveClassesQuery.data,
    flatMapLiveClassPages,
    flatMapCohostPages,
    liveClassesGuy: liveClasses,
    flatMapUpcomingCallPages,
  });

  const handleOpenChange = (newOpen: boolean) => {
    setOpenPopover(newOpen);
  };
  const handleClosePopover = () => {
    setOpenPopover(false);
    localStorage.setItem("hasSeenPopover", "true");
  };
  return (
    <>
      <StyledPageHeaderWrapper>
        {/* <StyledPageHeader>Upcoming events 📅</StyledPageHeader> */}
        <StyledPageHeader>Upcoming events</StyledPageHeader>
        {allEvents.length > 0 && (
          <StyledCreateButtonWrapper style={{display: "flex", justifyContent: "end"}}>
            <div className="show-desktop">
              <Button
                onClick={() => navigate("/new-offering")}
                // onClick={showOfferingCategoryModal}
                size="small"
                htmlType="button"
                type="primary"
              >
                <span className="show-desktop">Create a new offering</span>
              </Button>
            </div>
            <div className="show-mobile">
              <Backdrop
                style={{
                  top: 0,
                  left: 0,
                  right: 0,
                }}
                visible={openPopover}
              />
              <StyledPopover
                placement="bottom"
                color={"#F5F5F5"}
                autoAdjustOverflow
                overlayClassName="popover-guy"
                // arrowPointAtCenter
                overlayStyle={
                  {
                    // backgroundColor: "red",
                  }
                }
                content={
                  <div>
                    <p>Click on the “+” icon to create a new offering</p>
                    <div
                      style={{
                        marginTop: "1.6rem",
                        display: "flex",
                        justifyContent: "end",
                        gap: "2.4rem",
                      }}
                    >
                      <a
                        style={{
                          textDecoration: "underline",
                          fontWeight: 600,
                          fontSize: "1.4rem",
                        }}
                        onClick={() => {
                          handleClosePopover();
                          showOfferingCategoryModal();
                        }}
                      >
                        Try it now
                      </a>
                      <a
                        style={{
                          textDecoration: "underline",
                          fontWeight: 600,
                          fontSize: "1.4rem",
                        }}
                        onClick={() => handleClosePopover()}
                      >
                        Dismiss
                      </a>
                    </div>
                  </div>
                }
                title={null}
                trigger="click"
                visible={openPopover}
                afterVisibleChange={handleOpenChange}
              >
                <Button
                  onClick={showOfferingCategoryModal}
                  size="small"
                  htmlType="button"
                  type="primary"
                >
                  <PlusOutlined style={{fontSize: "2.4rem"}} />
                </Button>
              </StyledPopover>
            </div>
          </StyledCreateButtonWrapper>
        )}
      </StyledPageHeaderWrapper>

      {/* {(getLiveClassesQuery.data.length > 0 ||
        transactions.length > 0) && (
        <div style={{marginTop: "2rem", display: "flex", justifyContent: "end"}}>
          <Button
            onClick={showOfferingCategoryModal}
            size="small"
            
            htmlType="button"
            type="primary"
          >
            Create a new offering
          </Button>
        </div>
      )} */}
      {/* {connectCalendarStatus.connectCalendarStatus.needs_login && (
        <div style={{marginBottom: "2rem", maxWidth: "72rem"}}>
          <Alert
            message={
              <div style={{color: "#002421", fontSize: "1.4rem"}}>
                <Link
                  style={{fontWeight: 600, textDecoration: "underline"}}
                  to={getGoogleCalendarSettingsPath()}
                >
                  Connect your calendar
                </Link>
                <span>
                  {" "}
                  to let us know when you are available and update your calendar as you
                  get bookings.
                </span>
              </div>
            }
            style={{
              background: "#E1F6F5",
              border: "1px solid #50D3CD",
              borderRadius: "5px",
            }}
            // closable
            // afterClose={handleCloseConnectBankMessage}
          />
        </div>
      )} */}

      <div style={{marginTop: "2.4rem"}}>
        <Tabs defaultActiveKey="1">
          <Tabs.TabPane tab="All" key="1">
            {allEvents.length < 1 ? (
              <StyledNoUpcomingCallBox>
                <p className="info-text">
                  You do not have upcoming events at the moment.
                </p>
                <div>
                  <Button
                    onClick={showOfferingCategoryModal}
                    size="small"
                    block
                    type="primary"
                    htmlType="button"
                  >
                    Create a new offering
                  </Button>
                </div>
              </StyledNoUpcomingCallBox>
            ) : (
              <div>
                <div>
                  {getCoHostedEvent.data.pages.length > 0 &&
                    getCoHostedEvent.data.pages[0]?.data?.length > 0 && (
                      <Space direction="vertical" size={29} style={{display: "flex"}}>
                        {getCoHostedEvent.data.pages[0].data.map((liveClass) => (
                          <LiveClassCard
                            key={liveClass.id}
                            name={liveClass.name}
                            activeSession={liveClass.activeSession}
                            attendees={liveClass.attendees}
                            callPrice={liveClass.callPrice}
                            callPriceCurrency={liveClass.callPriceCurrency}
                            cover_image={
                              liveClass.cover_image
                                ? liveClass.cover_image
                                : liveClass.cover_images &&
                                  liveClass.cover_images.length > 0
                                ? liveClass.cover_images[0].media_url
                                : "/images/no-image-placeholder.png"
                            }
                            description={liveClass.description}
                            eventId={liveClass.id}
                            slug={liveClass.slug}
                            statusName={liveClass.statusName}
                            hostUsername={liveClass.hostProfile.username}
                            tiny_url={liveClass.tiny_url}
                            is_co_host
                            session_info={liveClass.session_info}
                            is_custom_room={liveClass.is_custom_room}
                            roomId={liveClass.roomId}
                            video_platform={liveClass.video_platform}
                          />
                        ))}
                      </Space>
                    )}
                </div>
                <div style={{marginTop: flatMapCohostPages.length > 0 ? 29 : 0}}>
                  <CallsSection />
                </div>
                {flatMapLiveClassPages.length > 0 && (
                  <div style={{marginTop: flatMapUpcomingCallPages.length > 0 ? 29 : 0}}>
                    <UpcomingClassesV2 data={flatMapLiveClassPages} />
                  </div>
                )}
              </div>
            )}
          </Tabs.TabPane>
          <Tabs.TabPane tab="1:1 Sessions" key="2">
            {flatMapUpcomingCallPages.length > 0 ? (
              <CallsSection />
            ) : (
              <StyledNoUpcomingCallBox>
                <p className="info-text">
                  You do not have upcoming sessions or sessions at the moment. Create a
                  new session to get started
                </p>
                <div>
                  <Button
                    onClick={showCallCategoryModal}
                    size="small"
                    block
                    type="primary"
                    htmlType="button"
                  >
                    Create a new 1:1 session
                  </Button>
                </div>
              </StyledNoUpcomingCallBox>
            )}
          </Tabs.TabPane>
          <Tabs.TabPane tab="Live events" key="3">
            {liveClasses.length < 1 ? (
              <div style={{width: "100%"}}>
                <StyledNoUpcomingCallBox>
                  <p className="info-text">
                    You do not have any live event at the moment. Create a new live event
                    to get started
                  </p>
                  <div>
                    <Button
                      onClick={() => navigate("/live-classes/new")}
                      // onClick={() => navigate("/live-classes/new")}
                      size="small"
                      block
                      type="primary"
                      htmlType="button"
                    >
                      Create new live event
                    </Button>
                  </div>
                </StyledNoUpcomingCallBox>
              </div>
            ) : (
              <Space
                direction="vertical"
                size={flatMapCohostPages.length > 0 ? 29 : 0}
                style={{display: "flex"}}
              >
                {getCoHostedEvent.data.pages[0]?.data?.length > 0 && (
                  <div>
                    <Space direction="vertical" size={29} style={{display: "flex"}}>
                      {getCoHostedEvent.data.pages[0].data.map((liveClass) => (
                        <LiveClassCard
                          key={liveClass.id}
                          name={liveClass.name}
                          activeSession={liveClass.activeSession}
                          attendees={liveClass.attendees}
                          callPrice={liveClass.callPrice}
                          callPriceCurrency={liveClass.callPriceCurrency}
                          cover_image={
                            liveClass.cover_image
                              ? liveClass.cover_image
                              : liveClass.cover_images &&
                                liveClass.cover_images.length > 0
                              ? liveClass.cover_images[0].media_url
                              : "/images/no-image-placeholder.png"
                          }
                          description={liveClass.description}
                          eventId={liveClass.id}
                          slug={liveClass.slug}
                          statusName={liveClass.statusName}
                          hostUsername={liveClass.hostProfile.username}
                          tiny_url={liveClass.tiny_url}
                          session_info={liveClass.session_info}
                          is_custom_room={liveClass.is_custom_room}
                          roomId={liveClass.roomId}
                          video_platform={liveClass.video_platform}
                          is_co_host
                        />
                      ))}
                    </Space>
                  </div>
                )}
                <UpcomingClassesV2 data={flatMapLiveClassPages} />
              </Space>
            )}
          </Tabs.TabPane>
        </Tabs>
        <CallCategoryModal
          okFunc={handleOk}
          cancelFunc={handleCancel}
          visibleState={openCallCategoryModal}
        />
        <CallOfferingModal
          okFunc={handleOfferingOk}
          cancelFunc={handleOfferingCancel}
          visibleState={openOfferingCategoryModal}
        />
      </div>
    </>
  );
};
